<div class="row">
    <div class="col-1">&nbsp;</div>
    <div class="col-10 p-3">

        <div class="row justify-content-center p-5" *ngIf="caseloading">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
            </div>
        </div>
        <div class="row" *ngIf="case && !caseloading">
            <div class="col-12">

                <div class="row">
                    <div class="col-12"><h2>{{case.subject}}</h2></div>
                </div>
                <div class="row p-1 banding">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.reference' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.caseNumber}}</div>
                </div>
                <div class="row p-1">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.type' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.type}}</div>
                </div>
                <div class="row p-1 banding">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.priority' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.priority}}</div>
                </div>
                <div class="row p-1">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.status' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.status}}</div>
                </div>
                <div class="row p-1 banding">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.asset' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                        <span>
                            {{assetDisplay}}
                        </span>
                    </div>
                </div>
                <div class="row p-1">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.customerReference' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.customerReference}}</div>
                </div>
                <div class="row p-1 banding">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.contact' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                        <span>
                            {{contactDisplay}}
                        </span>
                    </div>
                </div>
                <div class="row p-1 banding" *ngIf="case.action">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h4>True Positive</h4></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12"></div>
                </div>
                <div class="row p-1 banding pl-4" *ngIf="case.action">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.action' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.action}}</div>
                </div>
                <div class="row p-1 banding pl-4" *ngIf="case.subAction">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.subaction' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.subAction}}</div>
                </div>
                <div class="row p-1 banding pl-4" *ngIf="case.attributes">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.attributes' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.attributes}}</div>
                </div>
                <div class="row p-1 banding pl-4" *ngIf="case.killchain">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.killchain' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.killchain}}</div>
                </div>
                <div class="row p-1 banding pl-4" *ngIf="case.actor">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.actor' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.actor}}</div>
                </div>

                <div class="row p-1 banding" *ngIf="case.whyFalsePositive">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h4>False Positive</h4></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12"></div>
                </div>
                <div class="row p-1 banding pl-4" *ngIf="case.whyFalsePositive">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.why' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.whyFalsePositive}}</div>
                </div>
                <div class="row p-1 banding pl-4" *ngIf="case.whatFalsePositive">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.what' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.whatFalsePositive}}</div>
                </div>
                <div class="row p-1 banding pl-4" *ngIf="case.whoFalsePositive">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.who' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.whoFalsePositive}}</div>
                </div>


                <div class="row p-1">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.description' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12" [innerHTML]="case.description | cveify | signalify | safeHtml" *ngIf="case.description"></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12" *ngIf="!case.description"></div>
                </div>
                <div class="row p-1 pt-2 banding">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.created' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.createdDate | date: 'dd/MM/yyyy HH:mm'}}</div>
                </div>
                <div class="row p-1">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.updated' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.lastModifiedDate | date: 'dd/MM/yyyy HH:mm'}}</div>
                </div>
                <div class="row p-1 banding" *ngIf="case.closedDate">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.support.dashboard.fieldTitles.closed' | translate }}</h5></div>
                    <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{case.closedDate | date: 'dd/MM/yyyy HH:mm'}}</div>
                </div>

                <div class="row pt-2" *ngIf="case.comments.length > 0">
                    <div class="col-12"><h3>{{ 'pages.support.dashboard.fieldTitles.updates' | translate }}</h3></div>
                </div>
                
                <div class="row p-3" *ngIf="case.comments.length > 0">
                    <div class="col-12">

                        <ngb-accordion closeOthers="true">

                            <ngb-panel  *ngFor="let comm of case.comments;">
                                <ng-template ngbPanelTitle>
                                    <b>{{comm.creatorName}} - {{comm.createdDate | date: 'dd/MM/yyyy HH:mm'}}</b>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <p class="mb-1 preserve-whitespace">{{comm.commentBody}}</p>
                                    <br/>
                                    <small>{{comm.creatorName}} - {{comm.createdDate | date: 'dd/MM/yyyy HH:mm'}}</small>
                                </ng-template> 
                            </ngb-panel>
                            
                        </ngb-accordion>
                  
                    </div>
                </div>
                


                <div class="row pt-2 banding" *ngIf="!isClosed">
                    <div class="col-12">
                
                        <div class="p-5" *ngIf="postingComment">
                            <div class="spinner-border text-primary" role="status" style="float:left">
                                <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
                            </div>
                            <div class="pt-2 pr-2 ml-5">
                                <h6>Saving...</h6>
                            </div>
                        </div>  

                        <ngb-alert type="success" *ngIf="commentSuccessful">{{ 'pages.support.view.commentSaved' | translate }}</ngb-alert>
                        <ngb-alert type="danger" *ngIf="!commentSuccessful && commentError">{{commentError}}</ngb-alert>
                       
                        <form>
                            <div *ngIf="!postingComment">
                                <div class="form-row">
                                    <div class="form-group col-12" style="margin-bottom: 0;">
                                        <label for="exampleInputTicketRef">{{ 'pages.support.view.addComment' | translate }}</label>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <textarea class="form-control" id="desc" rows="8" name="comment" id="comment" aria-describedby="comment" [(ngModel)]="comment"></textarea>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <button type="button" (click)="postComment();" class="btn btn-primary">{{ 'pages.generic.save' | translate }}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                
                    </div>
                </div>

                <div class="row pt-3">
                    <div class="col-12"><h2>Attachments</h2></div>
                        <div class="col-12">            
                            <div class="list-group">
                                <a class="list-group-item list-group-item-action" *ngFor="let file of attachments; let i = index">
                                    <div class="d-flex w-100 justify-content-between"  (click)="downloadAttachment(file.id, file.name, case.id)" style="cursor: pointer;">
                                        <p class="mb-1 preserve-whitespace"><fa-icon [icon]="['far', 'file']" size="lg" [styles]="{'stroke': 'orange', 'color': 'orange'}"></fa-icon> {{file.name}}</p>
                                        <p class="mb-1 preserve-whitespace">Created: {{file.createdDate | date: 'dd/MM/yyyy HH:mm'}}</p>
                                    </div>
                                </a>
                            </div>                
                        </div>
                </div>

                <div class="row" *ngIf="!isClosed">
                    <div class="col-12 p-2">
                        <ngb-alert type="success"  (close)="close(alert)" *ngIf="attachmentSuccessful">{{ 'pages.support.view.fileUploaded' | translate }}</ngb-alert>
                        <ngb-alert type="danger" (close)="close(alert)" *ngIf="!attachmentSuccessful && attachmentError">{{attachmentError}}</ngb-alert>

                        <app-upload-files [caseRef]="caseRef" (flagEmitter)="refreshAttachments($event);"></app-upload-files>
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col-12 p-2">
                        <button type="button" [routerLink]="['/support/log/' + case.id]" routerLinkActive="router-link-active" class="btn btn-primary">{{ 'pages.support.view.edit' | translate }}</button>
                    </div>                 
                </div> -->

            </div>
        </div>

    </div>
    <div class="col-1">&nbsp;</div>
  </div>


